import React from "react";
import Returns from "./returns/returns";
import Growth from "./growth/growth";
import WithCard from "../../../common/withCard";
import "../../../PortfolioDashboard/dataGrid/table.css";
import "./backtest.css";
// import Selections from "./onselection/section1/selections";
// import Performance from "./performance/performance";

const Subbacktest = props => {
  console.log("******* props from backtest *******");
  console.log(props);
  return (
    <div>
      {/* <WithCard>
          <Selections scenario_id={scenario_id}/>
        </WithCard> */}
      <div className="text-center">
        <h4 className="text-uppercase bold clr_dark pt">
          portfolio backtest results: 2008-2018
        </h4>
      </div>
      <WithCard>
        {props.getPerfHistMetrics.length &&
        Object.keys(props.getBacktest).length > 0 ? (
          <Growth {...props} />
        ) : null}
      </WithCard>
      {props.getPerfHistMetrics.length ? <Returns {...props} /> : null}
      {/* {props.getPerfHistMetrics.length ? <Performance {...props}/> : null } */}
    </div>
  );
};
export default Subbacktest;



// WEBPACK FOOTER //
// ./src/components/PortfolioDashboard/navigationPages/backtest/backtest.jsx